import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-payments',
  templateUrl: './manage-payments.component.html',
  styleUrls: ['./manage-payments.component.css']
})
export class ManagePaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
